module.exports = __webpack_public_path__ + "img/9788991813724.cf93de83.jpg";